import { render, staticRenderFns } from "./ClassFilterNav.vue?vue&type=template&id=6b13bd34&"
import script from "./ClassFilterNav.vue?vue&type=script&lang=js&"
export * from "./ClassFilterNav.vue?vue&type=script&lang=js&"
import style0 from "./ClassFilterNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b13bd34')) {
      api.createRecord('6b13bd34', component.options)
    } else {
      api.reload('6b13bd34', component.options)
    }
    module.hot.accept("./ClassFilterNav.vue?vue&type=template&id=6b13bd34&", function () {
      api.rerender('6b13bd34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/ClassFilterNav.vue"
export default component.exports